import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../MyComponents/Footer";
import GuestNav from "../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../MyComponents/Hero2";
import heroContent from "./HeroContent";
import leftimg from "../../assets/quranLeftImg.png";
import rightimg from "../../assets/quranRightImg.png";
import QuranImg1 from "../../assets/QuranImg1.png";
import QuranImg2 from "../../assets/QuranImg2.png";
import QuranImg3 from "../../assets/QuranImg3.png";
import QuranImg4 from "../../assets/QuranImg4.png";
import QuranImg5 from "../../assets/QuranImg5.png";
import QuranImg6 from "../../assets/QuranImg6.png";
import CourseExplorer from "../../MyComponents/CourseExplorer";
import LearningStyle from "../../MyComponents/LearningStyle";
import Testimonials from "../../MyComponents/Testimonials";
import FAQs from "../../MyComponents/FooterPages/newfaq";

const courses = [
  { title: "Yassarnal Qur'an", image: QuranImg1 },
  { title: "Qur'an Recitation", image: QuranImg2 },
  { title: "Tafseer-ul-Qur'an", image: QuranImg3 },
  { title: "Learn Surahs by Heart", image: QuranImg4 },
  { title: "Islamic Knowledge Course", image: QuranImg5, path: "/islamicKnowledge" },
  { title: "Hifz ul Qur'an", image: QuranImg6 },
];

const QuranPortal = () => {
  const quranpage = heroContent.quranpage;
  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={quranpage.titlePart1}
        titlePart2={quranpage.titlePart2}
        description={quranpage.description}
        buttonText={quranpage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseExplorer
        title="Explore Our Fun & Skill-Boosting Quran Courses"
        highlightText="Quran Courses"
        courses={courses}
      />

      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default QuranPortal;
